export default {
  hsk_left_time: 'Sisa waktu',
  hsk_submit_paper: 'Kirimkan',
  hsk_rotate_device_title: 'Silakan putar perangkat ke mode lanskap',
  hsk_rotate_device_desc: 'Untuk pengalaman ujian terbaik',
  hsk_not_finished: 'Belum selesai',
  hsk_not_start: 'Belum mulai',
  hsk_finished: 'Selesai',
  hsk_if_test: 'Tes sebelumnya belum selesai. Lanjutkan?',
  hsk_start_again: 'Ulang kembali',
  hsk_go_on: 'Lanjutkan',
  hsk_if_save:
    'Yakin mau keluar? Semua jawaban akan disimpan sehingga Anda bisa lanjutkan lagi lain kali.',
  hsk_login_filed: '您的登录信息已失效，我们将不会保留您的答题记录',
  hsk_report: 'Hasil',
  hsk_point: 'Nilai',
  hsk_qualified_point: 'Nilai jawaban benar: {points}',
  hsk_part1: 'Bagian {part} ',
  hsk_accuracy1: 'Benar',
  hsk_test_again: 'Tes lagi',
  hsk_example: 'Contoh',
  hsk_example_eg: '例',
  hsk_answer_analysis: 'Penjelasan:',
  hsk_your_answer: 'Jawaban Anda:',
  hsk_audio_text: 'Audio:',
  hsk_correct_answer: 'Contoh:',
  hsk_listen_name: 'Kemampuan Mendengar',
  hskk_listen_name: 'Pemrograman perangkat',
  hsk_read_name: 'Kemampuan Membaca',
  hsk_write_name: 'Kemampuan Menulis',
  hsk_reference_answer: 'Contoh:',
  hsk_question_audio_content: 'Isi audio soal:',
  hsk_submit_msg: 'Kirimkan jawaban Anda?',
  hsk_homework_no_answer: 'Belum dijawab.',
  hsk_practice_sava: 'Yakin berhenti? Setelah keluar jawaban Anda tidak akan disimpan.',
  hsk_practice_go: 'Coba latihan',
  hsk_practice_part: 'Modul latihan',
  hsk_practice_operate: 'Kerjakan',
  hsk_practice_check: 'Lihat',
  hsk_practice_num1: 'Jawaban benar',
  hsk_practice_num2: 'Total: {totalNum} pertanyaan',
  hsk_preview_listen_msg:
    'Mainkan audio pengantar ujian. Sambil mendengarkan, Anda bisa meninjau pertanyaan untuk kemampuan mendengar.',
  hsk_preview_listen_prompt:
    '现在播放试卷说明，在此期间，可以点击答题卡中听力各部分的题号预览试题,考试过程中请不要刷新和关闭页面，否则作答数据将会丢失。',
  hsk_enter_next_segment_msg: 'Lanjutkan ke bagian selanjutnya?',
  hsk_enter_next_segment_preview: '是否结束预览？预览结束后，将开始听力环节的考试。',
  hsk_enter_next_segment_listen_tip: '你有{count}道听力题未作答，',
  hsk_enter_next_segment_listen: '是否提交听力？提交后，听力环节结束。',
  hsk_enter_next_segment_listen_review_start:
    '现在是听力回顾环节，您将拥有{count}分钟检查听力试题的作答情况。',
  hsk_enter_next_segment_listen_review: '是否结束听力回顾，听力回顾结束后，将开始阅读环节的考试。',
  hsk_enter_next_segment_read_tip: '你有{count}道阅读题未作答，',
  hsk_enter_next_segment_read: '是否提交阅读？提交后，阅读环节结束，无法返回进行修改。',
  hsk_enter_next_segment_write_tip: '你有{count}道写作题未作答，',
  hsk_enter_next_segment_write: '是否提交试卷？',
  hsk_end_preview: 'Akhiri pratinjau',
  hsk_submit_listen: 'Kirimkan jawaban kemampuan mendengar',
  hsk_end_review: 'Akhiri sesi ini',
  hsk_start_exam: 'Mulai',
  hsk_link_test: '全真模拟测试',
  hsk_link_tips: '做全真模拟试卷获取官方证书',
  hsk_buy: '购买',
  hsk_test_ready: 'Persiapan tes',
  hsk_test_ready_tips:
    'Ada latihan mendengar di dalam tes ini. Mohon sesuaikan pengaturan audio. Kami akan memainkan sebuah audio tes untuk Anda.',
  hsk_test_content: 'Isi tes',
  hsk_test_num: 'Jumlah pertanyaan',
  hsk_total_num: 'Total pertanyaan',
  hsk_test_time: 'Waktu',
  hsk_time_total: 'Total waktu',
  hsk_test_minute: 'menit',
  hsk_about: 'Tentang',
  hsk_abbreviation: 'Singkatan',
  hsk_determine_ans: 'Yakin Anda mau mulai?',
  hsk_determine_ans_tips: 'Setelah mulai Anda tidak bisa melihat teks aslinya lagi.',
  no_data: 'Tidak ada data',
  hsk_question_number: 'Jumlah pertanyaan',
  hsk_test_rate: '\r\r\nPersentase ujian',
  hsk_right_rate: 'Benar',
  hsk_operation: 'Kerjakan',
  hsk_skip: 'Lewati',
  hsk_spend: '花费',
  hsk_cost: '花费',
  hsk_credit: '余额',
  hsk_pay_successfully: '支付成功',
  hsk_select_amount: '选择充值金额',
  button_common_ok: 'Konfirmasi',
  button_common_cancel: 'Batalkan',
  change_lang_ok: 'Confirm',
  change_lang_cancel: 'Cancel',
  hint_player_loader_error: 'Gagal memainkan audio',
  hint_common_wait_loading: 'Mengunduh materi…',
  button_common_hand_in: 'Kirimkan',
  test_total_question: 'Total {count} pertanyaan',
  test_release: 'Terbitkan',
  test_off_shelf: 'Batal terbitkan',
  test_enable: 'Gunakan',
  test_record: 'Tes uji coba yang sudah dikerjakan',
  test_finish_time: 'Waktu penyelesaian',
  test_paper: 'Soal ujian',
  test_confirm_use: 'Terbitkan jawaban tes ujian',
  test_confirm_off_shelf: 'Batal terbitkan jawaban tes ujian',
  test_has_on_shelf: 'Tersedia',
  test_un_release: 'Belum diterbitkan',
  test_un_enable: 'Tidak tersedia',
  test_max_score: 'Nilai tertinggi',
  test_average_score: 'Nilai rata-rata',
  test_min_score: 'Nilai terendah',
  test_all: 'Semua',
  test_has_practiced: 'Sudah dikerjakan, lihat hasil',
  test_paper_office: 'Soal ujian sudah tidak teresedia lagi',
  test_complete_introduce: 'Penjelasan lengkap',
  test_course_link: '官方课程',
  test_about_down_load: 'Unduh',
  test_pay: 'Bayar',
  mark_answer_user: 'Orang yang mengumpulkan',
  mark_answer_time: 'Waktu pengumpulan',
  mark_correct_time: 'Wakti penilaian',
  mark_correct_status: 'Status penilaian',
  mark_correct_user: 'Penilai',
  mark_correct_option: 'Kerjakan',
  mark_correct_ing: 'Sedang dinilai',
  mark_un_correct: 'Belum dinilai',
  mark_has_correct: 'Sudah dinilai',
  mark_report_tips:
    'Catatan: Total nilai akhir belum termasuk bagian menulis. Pertanyaan 99-100 akan dinilai oleh penilai profesional dalam waktu 48 jam. Nilai akhir Anda akan diperbaharui dan Anda akan diberitahu lewat email.',
  mark_report_tips_hskk:
    'Catatan: Total nilai akhir belum termasuk bagian menulis. Pertanyaan akan dinilai oleh penilai profesional dalam waktu 48 jam. Nilai akhir Anda akan diperbaharui dan Anda akan diberitahu lewat email.',
  mark_submit_btn: 'Kirimkan',
  mark_submit_tips: 'Kirimkan jawaban Anda?',
  mark_back: 'Kembali',
    hsk_answer_sheet: 'Lembar Jawaban',
  mark_correct_tips: 'Tes uji coba ini sedang dinilai dan tidak bisa dimodifikasi.',
  mark_correct_person: 'Penilaian manual',
  search_user_message: 'Cari pengguna',
  mark_current_user: 'Nama pengguna',
  mark_correct_paper: 'Nilai',
  mark_all_status: 'Semua status',
  mark_all_level: 'Semua level',
  mark_overtime: 'Terlambat',
  mark_answer: 'Jawab',
  mark_ai_suggest_score: 'AI suggested score',
  home_test_registration: 'Daftar HSK',
  home_word_outline: 'Silabus',
  home_online_practice: 'Contoh',
  home_test: 'Soal Ujian',
  home_page: 'Beranda',
  common_text_control_speed: 'Kecepatan',
  button_common_playback: 'Mainkan rekaman',
  common_text_file_error: 'Gagal mengunduh materi. Mohon coba lagi.',
  common_text_server_error: 'Coba lagi',
  common_text_none_network: 'Jaringan tidak stabil',
  button_common_start_over: 'Coba lagi',
  evaluating_tips_common: 'Rekaman Anda dan teks sangat berbeda. Mohon coba lagi.',
  evaluate_common_total_score: 'Nilai',
  evaluate_common_training_remain: 'Sisa:',
  evaluate_common_training_readyRcord: 'Siap-siap untuk merekam',
  evaluate_common_training_atleast: 'Rekaman harus lebih dari 1 detik',
  evaluate_common_training_atleast2: 'Rekaman harus lebih dari 2 detik',
  evaluate_common_training_evaluting: 'Sedang dinilai',
  evaluating_tips_additionalAndBack: 'Ulangi rekaman',
  textbook_chioce_word_text_correct_tip: 'Jawaban benar. Hebat!',
  textbook_chioce_word_text_error_tip: 'Jawaban salah. Coba lagi!',
  textbook_reading_comprehension_stem: 'Kemampuan Membaca',
  spc_back_tips: 'Yakin Anda mau berhenti? Jawaban tidak akan disimpan.',
  spc_level_text: 'Menilai level',
  spc_capability_assessment: 'Penilaian kemampuan',
  spc_pick_level: 'Pilih Level',
  spc_listen: 'Kemampuan Mendengar',
  spc_speak: 'Kemampuan Berbicara',
  spc_read: 'Kemampuan Membaca',
  spc_write: 'Kemampuan Menulis',
  spc_translation: 'Terjemahan',
  spc_result_tips: 'Dari nilai tes ini, level bahasa Mandarin Anda adalah HSK {level}',
  spc_recommend_test: 'Kami sarankan Anda belajar untuk HSK {level}.',
  spc_recommend_test1: 'Kami sarankan Anda belajar untuk <strong> HSK {level}</strong>',
  spc_again_test: 'Tes lagi',
  spc_where_tips: 'Tak yakin level bahasa Mandarin Anda?',
  spc_immediate_test: 'Kerjakan tes ini',
  spc_test_content: '测试内容',
  spc_test_content_desc: '听力、阅读、书写及跟读(朗读)',
  spc_test_timer: '测试时间',
  spc_test_timer_desc: '预计15分钟，题目数量9-28左右，等级越高花费时间越长',
  spc_test_result: '测试结果',
  spc_test_result_desc: '帮助您快速定级，助力备考',
  vocab_level_word: 'Daftar kosakata {level}',
  vocab_total_item: 'Jumlah total {total}',
  vocab_search: 'Cari',
  vocab_all_marked: 'Semua',
  vocab_already_marked: 'Sudah ditandai',
  vocab_unmarked: 'Belum ditandai',
  vocabulary: 'Karakter',
  vocab_pinyin: 'Pinyin',
  vocab_translate: 'Arti',
  vocab_mark: 'Ditandai',
  delete_confirmation: 'Hapus kosakata?',
  cancel: 'Batalkan',
  del: 'Hapus',
  edit_vocab: 'Edit kosakata',
  save: 'Simpan',
  add_vocab: 'Tambah kosakata',
  hanzi: 'Karakter Mandarin',
  num_bihua: 'Goresan',
  write_demo: 'Animasi',
  vocab_side: 'Komponen',
  level: 'Level',
  see_more: 'Lihat lebih banyak',
  same_read_word: 'Sama bunyinya',
  samilar_read_word: 'Mirip bunyinya',
  add_mark: 'Tandai',
  word_team: 'Kata-kata',
  instance: 'Contoh kalimat',
  include_num_char: 'Terdiri dari {total} karakter Mandarin',
  length_diff: 'Jumlah suku kata Pinyin dan karakter Mandarin tidak konsisten',
  add_word_success: 'Kosakata berhasil ditambahkan',
  add_word_fail: 'Kosakata gagal ditambahkan',
  edit_word_success: 'Kosakata berhasil diedit',
  edit_word_fail: 'Kosakata gagal diedit',
  del_success: 'Berhasil dihapus',
  del_fail: 'Gagal dihapus',
  mark_free: 'Bisa bebas ditandai. Misalnya: Tandai sebagai "sudah dikuasai"',
  write_word_sentence: 'Tulis kalimat berdsasarkan kata-kata di atas',
  write_word_artical: 'Tulis essay pendek berdasarkan kata-kata di atas',
  write_img_artical: 'Tulis essay pendek berdasarkan gambar di atas',
  write_artical_title: 'Tulis judul artikel',
  write_artical_content: 'Tulis isi artikel',
  my_wallet: 'Dompet saya',
  learn_history: 'Lihat yang sudah dipelajari',
  manage: 'Kelola',
  birthday: 'Tanggal lahir',
  email: 'Email',
  change_pw: 'Ganti kata sandi',
  edit_info: 'Edit informasi pribadi',
  lastName: 'Nama keluarga',
  firstName: 'Nama',
  gender: 'Jenis kelamin',
  female: 'Perempuan',
  male: 'Laki-laki',
  non_disclosure: 'Lainnya',
  change_avatar: 'Ganti avatar',
  preview_avatar: 'Pratinjau',
  upload_image: 'Unggah gambar',
  change_image: 'Ganti gambar',
  enter_old_pw: 'Kata sandi lama',
  enter_new_pw: 'Kata sandi baru',
  enter_new_pw_again: 'Ketik kembali kata sandi baru',
  forget_pw: 'Lupa kata sandi',
  recharge: 'Isi ulang',
  left_balance: 'Sisa kredit',
  consume_log: 'Catatan pengeluaran',
  recharge_log: 'Isi ulang',
  consume_time: 'Tanggal / waktu',
  consume_source: 'Daftar penggunaan kredit',
  consume_money: 'Kredit',
  total_item_log: 'Total transaksi {total}',
  recharge_time: 'Tanggal / waktu',
  recharge_num: 'Kredit',
  recharge_money: 'Jumlah',
  recharge_method: 'Metode',
  learn_content: 'Bahan pelajaran',
  total_score: 'Total',
  view_result: 'Lihat hasil',
  management: 'Kelola',
  give_history: 'Sejarah',
  total_recharge: 'Total isi ulang',
  last_login: 'Terakhir log masuk',
  give: 'Berikan kredit',
  gifted: 'Berikan kredit',
  give_time: 'Tanggal / waktu',
  give_to_person: 'Penerima',
  opera_person: 'Diberikan oleh',
  give_to: 'Berika kredit kepada',
  old_password_empty: 'Kata sandi lama tidak boleh kosong',
  diff_password: 'Kata sandi tidak konsisten',
  change_pw_success: 'Kata sandi sudah diperbaharui',
  change_pw_fail: 'Gagal mengubah kata sandi',
  change_info_success: 'Informasi berhasil diperbaharui',
  change_info_fail: 'Informasi gagal diperbaharui',
  statistics_center: 'Lihat statistik',
  select_recharge_mount: 'Pilih jumlah isi ulang',
  waiting_pay: 'Pembayaran sedang diproses',
  has_no_resolve_credit: '尚未收到付款，请再次尝试购买.',
  complete_pay: 'Pembayaran berhasil',
  pay_fail: 'Pembayaran gagal',
  give_success: 'Kredit berhasil diberikan',
  give_fail: 'Kredit gagal diberikan',
  change_avatar_success: 'Avatar berhasil diperbaharui',
  change_avatar_fail: 'Avatar gagal diperbaharui',
  enter_family_name: 'Nama keluarga',
  enter_given_name: 'Nama',
  log_in: 'Log masuk',
  log_in_error: 'Gagal',
  email_address: 'Email',
  invalid_email_address: 'Alamat email tidak benar',
  password: 'Kata sandi',
  password_tip: 'Kata sandi harus memiliki 6-20 karakter',
  invalid_password: 'Format kata sandi salah',
  have_account: 'Aku sudah ada',
  sign_up: 'Daftar',
  sign_up_error: 'Pendaftaran gagal',
  forget_pw_success: 'Email untuk mengubah kata sandi berhasil dikirim',
  forget_pw_error: 'Email untuk mengubah kata sandi gagal dikirim',
  loading: 'Sedang memuat',
  account_block: 'Akun ini dinon-aktifkan',
  account_block_tip: 'Mohon hubungi Agen di sekolah atau organisasi Anda untuk info lebih banyak',
  resend_email: 'Kirim email kembali',
  resend_email_success: 'Email berhasil dikirimkan kembali',
  resend_email_error: 'Email gagal dikirimkan kembali',
  i_am: '我是',
  choose_role: 'Which one best describes you',
  choose_role_error: '选择角色失败',
  continue: '继续',
  learner: '学生',
  learner_description: 'I am learning Chinese',
  teacher: '教师',
  teacher_description: 'I am teaching Chinese',
  setup_account_error: 'Gagal membuat akun',
  tos_link: 'Ketentuan Penggunaan',
  privacy_link: 'Kebijakan Privasi',
  email_verified: 'Email sudah diverifikasi',
  email_verified_tip: 'Terima kasih sudah memverifikasi email Anda',
  email_verified_error: 'Gagal memverifikasi akun',
  something_wrong: 'Ada masalah',
  retry: 'Coba lagi',
  guardian_consent_error: 'Persetujuan gagal',
  about_us: 'Tentang Kami',
  feedback: 'Hubungi Kami',
  download: 'Unduh',
  submit: 'Kirimkan',
  feedback_success: 'Berhasil dikirim',
  feedback_error: 'Gagak dikirim',
  logout: 'Log keluar',
  my_account: 'Akun saya',
  login_signup: 'Log Masuk/Daftar HSK Mock',
  please_enter_content: 'Pesan Anda (harus diisi)',
  describe_detail: 'Jika Anda melaporkan masalah, mohon berikan detail sebanyak mungkin',
  upload_picture:
    'Unggah gambar paling banyak {maxFiles} (tak harus diisi), maksimum 2MB setiap gambar',
  file_error: 'Format atau ukuran salah',
  file_num_limit: 'Jumlah berkas maksimum: {maxFiles}',
  sure_change_lang: 'Ganti bahasa?',
  privacy_policy_text1: 'HSK Mock.com——Chinese Test International一Program Test Uji Coba Resmi',
  privacy_policy_text2:
    'Program tes uji coba ini dikembangkan oleh Wo Hui Mandarin dan Chinese Test International untuk memberikan pelatihan ujian praktik lengkap kepada para pelajar bahasa Mandarin.',
  privacy_policy_text3: 'Wo Hui Mandarin adalah partner dari Chinese Test International',
  privacy_policy_text4:
    'Chinese Test International adalah organisasi layanan ujian pendidikan Mandarin internasional yang berkomitmen untuk menyediakan layanan profesional dalam pendidikan Mandarin dan desain penelitian ujian, penelitian dan pengembangan teknologi, pelaksanaan ujian, pemasaran, dan aspek lainnya untuk memenuhi kebutuhan pelajar Mandarin dan lembaga pendidikan Mandarin di seluruh dunia.',
  privacy_policy_text5:
    'Didirikan di Singapura pada tahun 2018 oleh grup pendidikan internasional EiM, Wo Hui Mandarin adalah perusahaan independen yang didedikasikan untuk menyediakan dukungan teknis dan program belajar Mandarin untuk para pelajar Mandarin di seluruh dunia. Kursus yang unik dan beragam tersedia untuk siswa sesuai dengan tipe dan kebutuhan masing-masing membuat proses belajar menjadi sangat praktis dan efektif. Teknologi dan kecerdasan membantu pengajaran, membebaskan tangan guru, meningkatkan proses pengajaran, membantu siswa mencapai tujuan pribadi mereka sendiri, dan mendorong siswa untuk menjadi pembelajar mandiri yang unggul. ',
  privacy_policy_text6:
    'Chinese Test International dan Wo Hui Mandarin memiliki dasar kerja sama yang baik dan berkomitmen untuk promosi dan pengembangan pembelajaran bahasa Mandarin. Untuk menilai tingkat siswa dengan lebih akurat, melaksanakan pembelajaran yang ditargetkan, dan mensimulasikan lingkungan ujian yang sebenarnya, keduanya melakukan kerja sama strategis yang mendalam untuk sepenuhnya memenuhi kebutuhan belajar pelajar bahasa Mandarin.',
  level_test: 'Penilaian level',
  level_test_example:
    'Jika Anda tidak yakin tentang level Anda, ikuti tes cepat gratis untuk melihat level Anda dan tingkat tujuan pembelajaran selanjutnya.',
  download_app_mobile: '为了更好的使用体验，请使用桌面版访问hskmock.com或下载APP使用',
  common_video_failed: 'Audio gagal dimuat',
  member_error: 'Ada masalah dengan materi ini!',
  agree_policy:
    '我已阅读并同意<u class="strong"><a href="{url}" target="_blank">《用户协议》</a></u>和<u class="strong"><a href="{url}" target="_blank">《隐私政策》</a></u>',
  please_check: 'Mohon baca dan setuju dengan Aturan Penggunaan dan Kebijakan Privasi',
  media_devices_unsupported_browserLabel:
    'Kami menyarankan untuk menggunakan Google Chrome sebagai browser. Contoh penggantian setting untuk Windows 10: Settings-Application-Default application-Web browser-select Google Chrome',
  media_devices_help_title: '是否开启麦克风',
  media_devices_help_content: '您需要打开麦克风才能录制音频',
  batch_exist_user: '{number} sudah terdaftar',
  batch_and: 'dan',
  batch_un_exist_user: '{number} belum terdaftar',
  batch_from: 'Dari',
  batch_notes: 'Catatan',
  batch_something: 'Tulis sesuatu',
  batch_people_number: 'Penerima',
  batch_use_number2: 'Biaya',
  batch_operation_status: 'Status',
  batch_ing_status: 'Sedang diproses',
  batch_success: 'Berhasil',
  batch_failed: 'Gagal',
  batch_select: 'Pilih',
  common_to: 'Untuk',
  common_start_time: 'Mulai',
  common_end_time: 'Selesai',
  batch_search_tips: 'Pisahkan alamat email dengan menggunakan koma, maksimal 50 alamat email',
  common_un_exist: 'Belum terdaftar',
  common_invalid: 'Tidak berlaku',
  batch_all_give: 'Berikan kredit ke semuanya',
  batch_single_people: 'Perorangan',
  batch_all: 'Semuanya',
  batch_name: 'Nama',
  batch_added_credits: 'Kredit tambahan',
  batch_spent_credits: 'Pengeluaran kredit',
  batch_account_status: 'Status akun',
  batch_Added_total: 'Total penambahan',
  batch_spent_total: 'Total pengeluaran',
  batch_Remaining: 'Sisa',
  batch_Recipients: 'Penerima',
  batch_Active: 'Aktif',
  batch_search: 'Cari',
  certificate_details: '证书详细信息',
  get_official_mock_certificate: '获取官方模拟证书',
  certificate_tips: '证书的详细信息取自您的个人信息。请确认无误:',
  country: '国籍',
  select_country: '请选择国籍',
  email_to: '证书将通过电子邮件发送至:',
  polyphonic: '多音字',
  click_tips: '点击题号查看答案',
  download_tips: '成绩合格即可下载模拟考试证书',
  cancel_delete_account: '注销账号',
  cancel_confirm: '确认',
  user_apply_delete_account_title: '申请注销账号',
  user_apply_delete_account_confirm_tip: '确认您的登录信息',
  user_apply_delete_account_alwaysTip: '您现在要求永久删除您模拟考账号及相关个人数据。',
  user_apply_delete_account_confirm_tip2: '提交申请前，请确认您的身份。',
  user_apply_delete_account_desc:
    '您的账号{email}用于登录并使用于<a href="{wohuiLink}" target="_blank">Wo Hui Mandarin</a> 及 <a href="{mockLink}" target="_blank">HSK Mock</a>',
  user_apply_delete_account_desc2: '注销后将无法继续使用该账号登录上述应用。',
  user_apply_delete_account_wohui_title: '取消我会订阅',
  user_apply_delete_account_hsk_title: 'HSK Mock余额',
  user_apply_delete_account_next_tip: '单击“下一步”按钮，确认您已阅读并同意上述内容。',
  user_apply_delete_account_next_title: '下一步',
  user_apply_delete_account_confirm_tip11: '取消您的订阅后再完成您注销账号的请求',
  cancel_delete_ok: '好的',
  cancel_delete_request_send: '发送请求',
  user_apply_delete_account_confirm_tip8: '当您的订阅于{date}到期时，您的账号将永久删除',
  user_apply_delete_account_confirm_tip4: '我们将发送邮件至',
  user_apply_delete_account_confirm_tip5: '以确认您的账号已被删除',
  user_apply_delete_account_confirm_tip6: '取消您的请求请点击“取消”',
  user_apply_delete_data_always: '您想取消永久删除您的模拟考账号及相关个人数据的请求吗?',
  cancel_delete_yes: '确定',
  cancel_delete_no: '取消',
  user_cancel_delete_success: '我们已经取消您的请求，不会对您的HSK Mock账号进行注销。',
  user_cancel_subscribe_again: '您可以重新进行订阅。',
  user_apply_delete_account_confirm_tip9: '您的订阅截止日期为',
  user_apply_delete_account_confirm_tip10: '请您选择想要注销账号的时间',
  user_apply_delete_account_ok_btn_title: '订阅到期时',
  user_apply_delete_account_now_btn_title: '立刻注销',
  cancel_out_subscription_abnormal: '用户订阅信息异常',
  user_apply_delete_account_confirm_tip3:
    '您在Apple上有订阅，会自动向您收取费用，请在续订前取消您的Apple订阅',
  user_apply_delete_stripe_tip:
    '您的订阅Stripe会自动通过您的信用卡/借记卡中收取费用 请访问我们的网站',
  user_apply_delete_account_balance: '您的账户余额为',
  user_apply_delete_account_balance_tip: '一旦注销，余额将不会返还.',
  user_apply_delete_account_expire: '您的账号将于三日内注销',
  my_class_name: '我的班级',
  my_class_search: '搜索班级',
  my_class_total: '总计',
  my_class_people: '人',
  my_class_ci: '人次',
  my_class_number: '人数',
  my_class_ci_number: '次数',
  my_class_tips: '内圈：HSK和YCT分布占比',
  my_class_tips1: '外圈：HSK和YCT个等级分布占比',
  my_class_all_class: '全部班级',
  follow_lesson: '查看课程',
  real_paper: '进行全真模拟测试',
  start_answer: '开始作答',
  edit_message_date: '日期',
  edit_message_language: '语言',
  edit_message_zh: '中文',
  edit_message_en: '英文',
  edit_message_title: '标题',
  edit_message_content: '请输入正文',
  edit_message_show: '展示',
  edit_message_save_success: '保存成功!',
  edit_message_create_success: '新增成功!',
  edit_message_edit1: '编辑',
  edit_message_follow_notice: '查看通知',
  edit_message_textarea_tips: '如添加链接，请在连接后添加空格进行区分',
  edit_message_notifications: '编辑通知',
  edit_message_Send_time: '发送时间',
  edit_message_edit_notification: '编辑通知',
  edit_message_add: '新增通知',
  edit_message_from: '起始时间',
  edit_message_to: '终止时间',
  edit_message_new_add: '新增通知',
  currency: '货币选择',
  pay_failed: '页面未加载成功？',
  pay_un_finished: '无法完成付款',
  select_currency_tips: '如果您愿意，您可以从下面的下拉列表中选择不同的货币',
  change_currency_tips: '您可以随时在“我的帐户”下更改您的首选货币。',
  my_homework: '我的作业',
  my_homework_add: '布置作业',
  my_homework_all_classes: '全部班级',
  my_homework_paper: '试卷名称',
  my_homework_sent_to: '发送',
  my_homework_sent_on: '发送时间',
  my_homework_due_on: '截止时间',
  my_homework_submitted_assignees: '提交人数/发送人数',
  my_homework_class_hint: '班级名称周围的括号意味着试卷只分配至班级里部分学生',
  my_homework_delay_hint: '显示是否允许学习者在指定的截止日期和时间后提交作业',
  my_homework_add_send_assignment: '发送作业',
  my_homework_add_new_assignment: '新作业',
  my_homework_edit_assignment: 'Edit assignment',
  my_homework_add_assignment: 'Add assignment',
  my_homework_add_assignment_details: '1. 作业详情',
  my_homework_add_issue_time: '发布时间',
  my_homework_add_whether_submit: '是否允许在截止时间后提交',
  my_homework_add_note: '备注内容',
  my_homework_add_assignees: '2. 发送对象',
  my_homework_edit_add_assignees: '发送对象',
  my_homework_add_group: 'Group',
  my_homework_add_immediate_release: '立即发布',
  my_homework_add_time_release: '定时发布',
  my_homework_add_are: '是',
  my_homework_add_no: '否',
  my_homework_detail_back: '返回至我的作业',
  my_homework_detail_sent_to: '发送给',
  my_homework_detail_leamers_in: '位学生在',
  my_homework_detail_on: '在',
  my_homework_detail_to_complete_by: '发送完成在',
  my_homework_detail_add_assignee: '添加发送对象',
  my_homework_detail_assignee: '发送对象',
  my_homework_search_placeholder: '请输入搜索内容',
  my_homework_stu_sent_by: '发送人',
  my_homework_total_topic_count: '共{count}题',
  my_homework_time_full: '{min}分钟',
  my_homework_select_date_time: '选择日期时间',
  my_homework_delete_assignment_title: '删除作业',
  my_homework_delete_assignment_tips: '确定删除作业吗，删除后无法取消！',
  my_homework_assignment_add_fail: '发布失败!',
  my_homework_assignment_add_success: '发布成功!',
  my_homework_assignment_edit_success: '编辑成功!',
  my_homework_assignment_edit_fail: '编辑失败!',
  my_homework_assignment_delete_fail: '删除失败!',
  my_homework_assignment_delete_success: '删除成功!',
  my_homework_assignment_due_on: '截止时间',
  my_homework_assignment_product: '商品名称',
  my_homework_assignment_certificate: '证书',
  my_homework_assignment_reset: '重置',
  my_homework_assignment_reset_title: '是否重置所选的模块',
  my_homework_assignment_gifted: '赠送数量',
  my_homework_assignment_papers: '试卷',
  my_homework_assignment_send_to: '作业发送至',
  my_homework_assignment_close_tip: '当前作业发送还未保存，确认退出吗？',
  pay_callback_tips:
    '如果您在中国大陆，但不是中国公民，我们建议您使用Visa或Master卡。我们正在研究一种解决方案，该解决方案将支持您的微信、支付宝和银联卡。',
  no_available_class: '暂无班级可选择',
  payment_method: '支付方式',
  wechat_pay: '微信支付',
  alipay_payment: '支付宝支付',
  card_payment: '银联支付',
  card_payment_description: '仅支持中国境外银行卡',
  payment_to_wohui: '向我会我汇我慧科技（上海）有限公司支付',
  order_submitted: '订单提交成功，请尽快付款！',
  order_number: '订单编号：',
  code_expires:
    '距离二维码过期还剩 <span style="color: #fc5a5a;font-size: 16px;font-weight: 500;">{time}</span>',
  use_weChat: '请使用微信扫一扫，扫描二维码支付',
  code_expired: '当前二维码已失效',
  amount_payable: '应付金额：',
  use_code: '使用兑换码',
  tests: '考试记录',
  level_title: '您的目标等级是什么？',
  level_des:
    '如果您不确定，可以参与一次<b style="color: #000;cursor: pointer;font-weight: 700;" class="clickable">免费的水平自测 ></b>',
  level_HSK_text1: '<b>HSK</b>是“中文水平考试”的拼音缩写，意思是中文水平测试。',
  level_HSK_text2: '这是全世界最受欢迎的中文水平测试。',
  level_YCT_text1: '<b>YCT</b>  是“中小学生中文水平考试”的英文缩写，',
  level_YCT_text2: '意思是为中小学生提供的中文水平测试。',
  level_BEGINNER: '初级',
  level_INTERMEDIATE: '中级',
  level_ADVANCED: '高级',
  level_dialog_title: '等级测试',
  level_dialog_content:
    '免费水平自测大约需要15分钟，测试结果将显示您目前达到的HSK水平以及您在四项语言技能（听、读、写、说）与该水平的接近程度。',
  level_dialog_login: '登录/注册',
  level_dialog_start: '开始水平测试',
  about_us_first_paragraph:
    'HSK Mock adalah satu-satunya program tes uji coba HSK dan YCT yang dibuat oleh dewan pemeriksaan dengan menggunakan pertanyaan sesungguhnya dari ujian yang sudah lewat. HSK Mock dibuat oleh Chinese Test International bekerjasama dengan Wo Hui Mandarin. Program ini dapat diakses menggunakan browser secara online atau dengan mengunduh aplikasi Android atau iOS.',
  about_us_second_paragraph:
    'Chinese Test International adalah dewan pemeriksaan untuk HSK dan YCT. Perusahaan terbatas ini berkantor pusat di Beijing dan berdedikasi untuk memberikan pelayanan khusus untuk memenuhi kebutuhan pelajar bahasa Mandarin dan institusi belajar bahasa Mandarin di seluruh dunia melalui pemasaran dan mempromosikan studi dan pengujian bahasa Mandarin; penyelenggaraan ujian, pengembangan teknologi; dan penelitian dan pengembangan pendidikan.',
  about_us_third_paragraph:
    'Wo Hui Mandarin adalah perusahaan teknologi pendidikan dengan misi membuat belajar bahasa Mandarin menjadi mudah dan bermanfaat. Perusahaan ini berkantor pusat di Singapura dan merupakan bagian dari grup Education in Motion. Mereka memanfaatkan teknologi untuk menempatkan pembelajaran bahasa Mandarin ke tangan siswa dan memberdayakan guru mereka untuk mendukung para siswa dalam perjalanan belajar pribadi mereka.',
  about_us_cti_text: '了解更多：',
  about_us_wohui_text: '如果您想了解更多，请联系：',
  listening_section: '听力部分',
  reading_section: '阅读部分',
  writing_section: '书写部分',
  review_answers: '检查答案',
  characters_long: '如果您还未注册账户，请设置一个6到20个字符的密码。',
  complete_profile: '完成个人资料',
  verify_email: '验证您的电子邮件',
  link_sent: '感谢您的注册。请点击我们发送给您的链接以验证是否为您的正确的电子邮件地址:',
  resend_link: '重新发送链接 >',
  restart: 'Restart',
  parental_consent: '父母知情',
  sent_parental: '感谢您的注册。请按照我们在电子邮件中发送的指示，征得您父母或监护人的同意:',
  thank_you: '感谢！',
  or_return: '或返回程序',
  child_profile: '您小孩的个人资料',
  sign_up_privacy:
    '我已阅读并同意<a class="link" target="_blank" rel="noopener noreferrer" href="{url}">《服务条款》</a>和<a class="link" target="_blank" rel="noopener noreferrer" href="{userUrl}">《隐私政策》</a>',
  give_consent: '我同意',
  delete_child_details: '删除孩子的信息',
  account_created: '创建账户',
  emailed_know: "我们已经发邮件给<span style='font-weight: 700'>{email}</span>让他们知情。",
  account_deleted: '删除账户',
  child_know_deleted: '请让您的孩子知道他们的详细信息已被删除。',
  request_email:
    '以上信息（邮箱地址除外）在登录后都可更新。请您同意您的孩子创建帐户，否则请要求我们删除他们的详细信息。',
  preferred_currency: '首选货币',
  parent_guardian: '父母/监护人',
  class_name: '班级名',
  tofficial_platform: 'HSK官方唯一模拟考试平台',
  proficiency_tests: '为世界上最受欢迎的中文水平考试做准备',
  get_started: '开始',
  platform_china: '本平台也为中国大陆的考生提供帮助。',
  take_confidence: '参加HSK考试胜券在握',
  practice_tests: 'HSK 及 YCT实战演练',
  using_time:
    '使用汉考官方提供的最新真题试卷，熟悉各类题型，掌握考试要求，提升答题速度，顺利完成考试。',
  instant_results: '及时得到反馈',
  each_test_question:
    '逐一回看已完成的每道考题，你能看到得分，还能看到解题详情，也能看到正确答案。了解自己的得失因由，改正错误、明确方向，走向成功。',
  track_progress: '记录进步足迹',
  ready_next_test:
    '平台会自动记录你每次模拟考试的日期和时间，以及每一次技能的提高与成绩变化。这些记录将提示你何时是参加真正考试的最佳时机，届时将取得最佳成绩。',
  receive_official_certificates: '获得官方证书',
  certificates_provide_evidence:
    '为您通过的每一次模拟考试提供证书。这些证书证明您已经具备一定的中文水平。',
  ready_next_level: '开启下一阶段',
  check_description:
    '查看下一关的说明以明确自己的目标。重温考试的要求与规则，复习规定的词汇，预览考试的内容，掌握考试的技巧。',
  on_the_move: '移动端使用？',
  download_mobile: '点击以下按钮下载移动端App',
  hsk_beginner_advanced:
    '<span style="font-weight: 700">HSK</span>是“中文水平考试”的拼音缩写，意思是中文水平测试。这是全世界最受欢迎的中文水平测试。从初级到高级一共有6个等级。',
  more: '更多 >',
  ytc_beginner_advanced:
    "<span style='font-weight: 700'>YCT</span>是“中小学生中文水平考试”的英文缩写，意思是为中小学生提供的中文水平测试。从初级到中级一共有4个等级。",
  coming_end: '2023年底上线口语模考',
  candidates_proficiency_speaking: '这是测试考生说中文的能力。',
  level_oral_tests:
    "<span style='font-weight: 700'>HSKK</span>是“中文水平口语考试”的拼音缩写，意思是中文口语水平测试。",
  check_test_dates: '查看考试日期',
  book_test: '报名考试',
  international_platform:
    '中国平台设在中国大陆内；国际平台设在新加坡。两个平台是彼此独立。请选择适合您的平台。',
  mock_platform: '官方模拟考试平台',
  home_proficiency_tests: '为最受欢迎的中文水平测试做准备',
  currency_type: '货币选择',
  Pick_your_level: '选择您的等级',
  About_this_level: '等级介绍',
  test_session: '次测试',
  Learning_resources: '学习资源',
  Take_practice_test: '模拟考试',
  Compare_syllabuses: '对比大纲',
  table_shows_syllabuses: '该表显示了不同大纲的HSK的水平。',
  forrgin_lang: '0547是“中文作为一门外语”',
  Second_Language: '0523是“中文作为第二语言”',
  Requirement_entry: '注册条件',
  most_Chinese_universities: '大部分中国大学',
  Qing_Hua: '清华大学',
  beijing_university: '北京大学',
  working_towards: '经过测试，推荐你备考',
  On: '在',
  Level_test: '等级测试',
  Retake_level_test: '重考',
  practice_test: '参与一次考试练习',
  Compare_syllabuses_a: '不同课程大纲和HSK大纲对比',
  Not_sure: '不确定自己的水平？',
  free_level_test: '参与免费水平自测',
  Examples: '例题',
  product_code: '产品兑换码',
  enter_paper: '输入兑换码以参与测试',
  no_code: '没有兑换码？请从我们的合作伙伴处购买：',
  to_partner: '转到合作伙伴链接',
  code_here: '请在此输入兑换码',
  start_assigment: 'Start',
  view_assigment: 'View',
  continue_assigment: 'Continue',
  choose_method: '选择解锁方式',
  choose_new_method: '请选择解锁新测试的方法。',
  browser_layer: '请在PC上使用Google Chrome浏览器或在移动设备上使用APP',
  partner_title1: '希望您能成为',
  partner_title2: '本地合作伙伴',
  company_name: '公司名称',
  company_website: '公司网站',
  teachers_count: '与您合作的HSK老师的数量',
  learners_count: '与您合作的HSK学生的数量',
  add_msg: '欢迎留言给我们',
  contact_style: '如何联系您?',
  send: '点击发送',
  partner_forms_desc:
    '作为我们的当地合作伙伴，您将成为您所在国家或地区的考生、教师、中小学和大学的主要联系人。<br><br>我们的合作伙伴通常是成熟的HSK考试和培训中心，他们希望扩大业务规模并提升官方认可度。<br><br>如果您想成为我们的当地合作伙伴，请先使用个人HSK模拟账户<span style="color: #faae56; text-decoration-line: underline; cursor: pointer">登录</span>并填写以下信息，我们会尽快和您取得联系。',
  submit_success: '发送成功',
  help_students_for_testing: '您正在帮助学生备考吗？',
  help_students_for_testing_desc:
    '教师在帮助学生达到下一个考试目标方面发挥着至关重要的作用。<br>赋能老师为学生提供个性化学习支持。',
  become_partner: '成为我们的当地合作伙伴',
  become_partner_desc:
    '对考生而言，能够用自己的母语与本地考点联系询问考试详情，且可以选用喜欢的本地支付方式付款。',
  partnership: '探索合作',
  students_forward: '助力您的学生',
  hsk_confidence: '参加HSK考试胜券在握',
  try_it_out: '立即体验',
  walk_through: '熟悉考试流程',
  teachers_page_desc1:
    '平台的功能不但支持班级教学，也适合一对一的教学。让学生熟悉各类题型，复习规定的词汇，预览考试的内容，掌握考试的技巧。',
  assign_practice_papers: '设置学生交卷截止日期和时间',
  teachers_page_desc2:
    '并发布试卷给您的学生。您可以将模拟试卷作为正式考试，帮助学生熟悉HSK考试的不同题型，让他能够在规定的时间内完成各个部分的作答。',
  get_instant_results: '即时反馈成绩',
  teachers_page_desc3:
    '无需教师人工批阅试卷。查看班级学生是否已经完成指定试卷。查看学生每一份试卷的成绩。',
  review_their_answers: '回顾学生作答情况',
  teachers_page_desc4:
    '能够逐个班级、逐个技能、逐个部分甚至逐个问题地深入了解学生的考试成绩。回顾学生的作答情况，您能准确地为学生制定教学方案，提供针对性的反馈。',
  track_prog: '跟踪学生进度',
  teachers_page_desc5:
    '详细记录学生每一次考试的成绩， 并提供试卷每题的答题情况，以及每一次技能的提高与成绩变化。这些记录提示教师，学生何时是参加真正考试的最佳时机，届时将取得最佳成绩。',
  students_next_level: '让学生更上一层楼',
  teachers_page_desc6:
    '我们的姐妹平台提供官方HSK和YCT课程材料，以及您所需要的教学工具和资源，赋能老师为学生提供个性化学习支持。',
  teaching_resources: '教学资源',
  for_teachers: '教师',
  teachers_desc1:
    '请先使用您的个人账号<span style="color: #faae56; text-decoration-line: underline; cursor: pointer">登录</span> HSK Mock模拟考试平台。',
  teachers_desc2: '请在下方填写基本信息，我们将为您的学校开通免费试用。',
  school_name: '学校名称',
  school_web: '学校网站',
  num_of_hsk_teachers: 'HSK教师人数',
  num_of_hsk_learners: 'HSK学生人数',
  hsk_submit_reading: 'Kemampuan Membaca',
  pay_tip: '如果您以支付宝或微信支付购买模拟试卷，请使用中国大陆服务网页hskmock.cn。',
  use_pc_or_app: '立即体验， 请用电脑登录或下载我们的APP。',
  download_certificate: '下载证书',
  create_certificate: '生成证书',
  certificate_is_downloaded: '证书已下载',
  pay_discount_title: '您想购买多少次{level}的全真模拟考试？',
  total: '总计',
  pay: '支付',
  price_desc:
    '您只需支付全真模拟考试的费用。您如果一次性购买多次全真模拟考试，单次考试即可获得一定折扣。',
  the_level: '等级',
  discounted_price: '价格',
  price_contact_us:
    '我们还为学校和机构提供批量购买的服务。请<span style="color: #faae56; text-decoration-line: underline; cursor: pointer">联系我们</span>讨论您的具体需求。',
  get_a_discount: '获取折扣',
  finished_pay_discount_title: '以下是您{level_name} 全真模拟试卷的兑换码。',
  btn_goto_papers: '查看{level_name}试卷',
  test_count: '{test_num}次测试',
  unit_price: '{price}/次测试',
  buy_code_tip:
    '我们已将这些兑换码通过电子邮件发送给您。现在只需选择您要测试的 {level_name} 试卷，输入兑换码即可解锁。',
  discount_codes_left_tip:
    '测试结束后，您在当前等级将<span style="color: #62C1A5;font-size: 16px;font-weight: 500;">剩余{count}个</span>兑换码。',
  manage_class: '管理班级',
  to_manage_class: '班级管理系统将在新标签页中打开。完成后，请返回此标签页并刷新页面。',
  code_used: '已使用',
  code_can_be_used: '未使用',
  no_test: '数量',
  history_purchase_quantity: '数量',
  hsk_listen_part_title: 'Kemampuan Mendengar: Bagian {count}',
  hsk_read_part_title: 'Kemampuan Membaca: Bagian {count}',
  hsk_write_part_title: 'Kemampuan Menulis: Bagian {count}',
  Description: '介绍',
  Test_format: '考试形式',
  Vocabulary: '词汇',
}
